






















































































































































































































































































































































































































































































































































































































































































































































import PageTitle from '@/components/common/PageTitle.vue';
import OrderDetails from '@/components/order/mixins/OrderDetail';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import OrderProductInfo from '@/components/order/detail/OrderProductInfo.vue';

import TaskContentList from '@/components/common/order/detail/TaskContentList.vue';
import CsList from '@/components/common/order/detail/CsList.vue';
import SyncFailList from '@/components/order/detail/SyncFailList.vue';

import { uniqBy } from 'lodash'

import {Component, Mixins, Watch} from 'vue-property-decorator';
import {
  GetOrderOptionsDetailSummaryViewRequest,
  GetPaymentsRequest,
  PostCsAdminRegisteredCsRequest
} from 'supporter';
import {i18nObjectByKey} from '@/utils/i18n';
import {addClass, removeClass} from '@/utils/classUtils';
import {namespace} from 'vuex-class';
import {Admin} from '@/types';
import {OrdersExternalFailHistory} from 'ncp-api-supporter';

const adminModule = namespace('admin');

@Component({
  components: {
    PageTitle,
    CompSelectBox,
    TaskContentList,
    CsList,
    SyncFailList,
    OrderProductInfo
  }
})
export default class OrderDetail extends Mixins(OrderDetails) {
  @adminModule.Getter('admin') private admin!: Admin;

  @Watch('showProductDetail')
  showProductDetailChange(next: any): void {
    if (next) {
      addClass(document.body, 'scroll_not');
    } else {
      removeClass(document.body, 'scroll_not');
      this.productLayerData = [];
    }
  }
  public escrowPayType: boolean = false;
  private syncFailList: OrdersExternalFailHistory[] = [];

  private created(): void {
    this.returnDetailData = i18nObjectByKey(this, this.returnDetailData, 'title');
    this.productDataPop = i18nObjectByKey(this, this.productDataPop, 'title');
  }
  private mounted(): void {
    this.getSummary();
    this.getDeliveryCompanies();
    this.getOrderInfo();
    this.getPaymentInfo();
    this.fetchOrdersExternalFailHistory();
    this.fetchFreeGiftsInfo();
  }
  private destroyed(): void {
    removeClass(document.body, 'scroll_not');
  }
  private handleAddCs(): any {
    if (!this.cs.content) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_8'));
      return;
    }
    let addCsRequest: PostCsAdminRegisteredCsRequest = {
      data: {
        orderNo: this.$route.query.orderNo as any,
        csStatusType: this.cs.csStatusType,
        csType: this.cs.csType,
        orderOptionNo: this.cs.orderProductOptionNo,
        csPathType: this.cs.csPathType,
        content: this.cs.content
      }
    };
    this.$api.postCsAdminRegisteredCs(addCsRequest).then((): any => {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_9'));
      this.initCs();
      this.csContentInput();
      (this.$refs.csList as any).handleGetCs();
    });
  }

  private handleGetTaskInfo(): void {
    let task: any = this.$refs.taskContent;
    task.getTasks();
  }
  private postTaskInfo(): void {
    let orderProductNm = '';
    let toTargetNo = this.serviceNo;
    if (!this.task.orderProductOptionNo) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_10'));
      return;
    }
    if (!this.task.content) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_11'));
      return;
    }
    this.orderProductOptionNoArr.map((item: any) => {
      if(item.value === this.task.orderProductOptionNo) {
        orderProductNm = item.label.split('|')[0];
        if(this.task.taskMessageTargetType === 'PARTNER') {
          toTargetNo = item.partnerNo;
        }
      }
    });
    let taskRequest: any = {
      data: {
        taskMessageStatusType: this.task.taskMessageStatus,
        orderNo: this.$route.query.orderNo as any,
        taskMessageChannelType: 'SERVICE',
        orderProductOptionNo: this.task.orderProductOptionNo,
        toTargetNo: toTargetNo,
        taskMessageType: this.task.taskMessageType,
        toTargetType: this.task.taskMessageTargetType,
        content: this.task.content,
        productName: orderProductNm
      }
    };
    this.$api.postTaskMessages(taskRequest).then((): any => {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_12'));
      this.initTask();
      this.taskContentInput();
      this.handleGetTaskInfo();
    });
  }
  private getPaymentInfo(): void {
    let paymentRequest: GetPaymentsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getPayments(paymentRequest).then((res): any => {
      this.paymentInfo = [];
      this.paymentInfo = res.data;
      this.serviceNo = this.paymentInfo[0].serviceNo;
      this.getUsePaymentInfo(this.paymentInfo);
    });
  }
  private getSummary(): void {
    let detailSummary: GetOrderOptionsDetailSummaryViewRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrderOptionsDetailSummaryView(detailSummary).then((res): any => {
      this.summaryOrderNo = res.data.orderNo;
      this.summaryCancelCnt = res.data.cancelCnt;
      this.summaryOrderCnt = res.data.orderCnt;
      this.summaryReturnCnt = res.data.returnCnt;
      this.summaryRowCnt = res.data.rowCnt;
    });
  }
  private handleEmitOrderProductInfo(info: any): void {
    this.getTotalAccumulation(info);
  }
  private handleEmitProductInfo(info: any): void {
    this.productInfo = [];
    this.productInfo = [...info];
    this.getPayInfo(this.productInfo);
    this.$set(this.orderInfo, 'orderRegisterType', this.productInfo[0].orderRegisterType);
    this.formatterProductOption(this.productInfo);
    this.getProductUrl(this.productInfo);
    this.getTaskProductOptions();
    this.getOtherPayList();
    this.getReturnListAndPayList();
  }
  private getOrderInfo(): void {
    let orderRequest: any = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrdersByOrderNo(orderRequest).then((res: any): any => {
      this.handleOrderInfo(res.data);
      this.getOrderMemberInfo(res.data);
      let order: any = res.data;
      this.initPayInfo = {};
      this.endPayInfo = {};
      this.escrowPayType = res.data.payType.indexOf('ESCROW') != -1;
      this.setFreeGiftDiscountAmount(res.data);
      this.initPayInfo = {
        salePrice: (order.firstBalance.standardAmt - order.firstBalance.immediateDiscountAmt).toLocaleString(),
        deliveryAmt: order.firstBalance.deliveryAmt.toLocaleString(),
        totalDeliveryAmt: (order.firstBalance.deliveryAmt + order.firstBalance.remoteDeliveryAmt - order.firstBalance.deliveryCouponDiscountAmt).toLocaleString(),
        couponAmt: (this.freeGiftDiscountAmount + order.firstBalance.additionalDiscountAmt + order.firstBalance.productCouponDiscountAmt + order.firstBalance.cartCouponDiscountAmt).toLocaleString(),
        payAmt: order.firstBalance.payAmt.toLocaleString(),
        accumulationAmt: order.firstBalance.subPayAmt.toLocaleString(),
        realPay: (order.firstBalance.payAmt - order.firstBalance.subPayAmt).toLocaleString()
      };
      this.endPayInfo = {
        salePrice: order.lastBalance.standardAmt - order.lastBalance.immediateDiscountAmt,
        deliveryAmt: order.lastBalance.deliveryAmt.toLocaleString(),
        totalDeliveryAmt: (order.lastBalance.deliveryAmt + order.lastBalance.remoteDeliveryAmt - order.lastBalance.deliveryCouponDiscountAmt).toLocaleString(),
        couponAmt: (this.freeGiftDiscountAmount + order.lastBalance.additionalDiscountAmt + order.lastBalance.productCouponDiscountAmt + order.lastBalance.cartCouponDiscountAmt).toLocaleString(),
        payAmt: order.lastBalance.payAmt.toLocaleString(),
        accumulationAmt: order.lastBalance.subPayAmt.toLocaleString(),
        realPay: (order.lastBalance.payAmt - order.lastBalance.subPayAmt).toLocaleString(),
        editReturnPay: this.editReturnPay
      };
    });
  }

  private hasRefundAccount(returnDetailItem: any): boolean{
    return returnDetailItem.refundBankAccount?.account === undefined || returnDetailItem.refundBankAccount.account.length === 0
  }

  public handleReceiverEmail() {
    if (confirm('임시비밀번호 발급 메일을 발송하시겠습니까? ')) {
      const request = {
        params: {
          orderNo: this.$route.query.orderNo as string,
        },
      };
      this.$api.putOrderInitializePassword(request).then((): any => {
        alert('발송하였습니다.');
      });
    }
  }

  // orderInfoPayType이 첨부터 한글로 set되어 한글과 비교
  private get isNaverPay(): boolean{
    return this.orderInfoPayType === '네이버페이 주문형';
  }

  private syncNaverOrder(){
    this.$api.putNaverPaySyncProductOrder({params: {orderNo: this.$route.query.orderNo.toString()}})
      .then(()=> {
        alert('동기화되었습니다.')
        location.reload();
      }).catch(()=>{
      alert('동기화 실패하였습니다.')
    })
  }

  private async fetchOrdersExternalFailHistory(){
    const {data} = await this.$api.getOrdersExternalFailHistory({
      params: {
        orderNo: this.orderNo,
      }
    });

    this.syncFailList = data;
  }
  
  private async fetchFreeGiftsInfo() {
    const { data } = await this.$api.getOrdersByOrderNoFreeGifts({
      pathParams: {
        orderNo: this.orderNo
      }
    });
    
    this.freeGifts = uniqBy(data, 'conditionNo');
  }
}

